export default {
  header: 'Ops, si è verificato un errore imprevisto',
  text: 'Riavvia la pagina o clicca sul pulsante “Torna al Menu” in basso.',
  button: "Torna all'inizio",
};
